import { CbInputModule } from '@chubb/ui-components/cb-input';
import { CbSpinnerModule } from '@chubb/ui-components/cb-spinner';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductsComponent } from './products.component';
import { RouterModule, Routes } from '@angular/router';
import { FloatingLeftColumnModule } from '../floating-left-column/floating-left-column.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CoverhoundModule } from './../../../components/coverhound/coverhound.module';
import { ProgressBarModule } from '../../../progress-bar/progress-bar.module';
import { ErrorBoxModule } from './../../../components/error-box/error-box.module';
import { AppAnalyticsModule } from '../../../directives/app-analytics.module';
import { ProductsTileModule } from './products-tile/products-tile.module';
import { ReferralMessageModule } from '../referral-message/referral-message.module';
const route: Routes = [
    {
        path: '',
        component: ProductsComponent,
    },
];
@NgModule({
    imports: [
        CommonModule,
        FloatingLeftColumnModule,
        RouterModule.forChild(route),
        CbInputModule,
        CoverhoundModule,
        CbSpinnerModule,
        ProgressSpinnerModule,
        ProgressBarModule,
        ErrorBoxModule,
        AppAnalyticsModule,
        ProductsTileModule,
        ReferralMessageModule,
    ],
    declarations: [ProductsComponent],
    exports: [ProductsComponent],
})
export class ProductsModule {}
